// extracted by mini-css-extract-plugin
export default {"container":"container--mKlxc","root":"root--ueCYS","top":"top--QwWks","icon":"icon--hu29E","hidden":"hidden--wlEqS","rotate":"rotate--jAH0X"};